import { render, staticRenderFns } from "./CaseStudyCustomerDetailCard.vue?vue&type=template&id=5925ab66&scoped=true&"
import script from "./CaseStudyCustomerDetailCard.vue?vue&type=script&lang=js&"
export * from "./CaseStudyCustomerDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudyCustomerDetailCard.vue?vue&type=style&index=0&id=5925ab66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925ab66",
  null
  
)

export default component.exports